import { ReactComponent as SvgAddAddress } from './glyphs/AddAddress.svg.es.js';
import { ReactComponent as SvgAddAllowListed } from './glyphs/AddAllowListed.svg.es.js';
import { ReactComponent as SvgAddPayment } from './glyphs/AddPayment.svg.es.js';
import { ReactComponent as SvgAllContracts } from './glyphs/AllContracts.svg.es.js';
import { ReactComponent as SvgBlog } from './glyphs/Blog.svg.es.js';
import { ReactComponent as SvgBuild } from './glyphs/Build.svg.es.js';
import { ReactComponent as SvgCheckInCircle } from './glyphs/CheckInCircle.svg.es.js';
import { ReactComponent as SvgClock } from './glyphs/Clock.svg.es.js';
import { ReactComponent as SvgContractTemplate } from './glyphs/ContractTemplate.svg.es.js';
import { ReactComponent as SvgCreditCard } from './glyphs/CreditCard.svg.es.js';
import { ReactComponent as SvgDefi } from './glyphs/Defi.svg.es.js';
import { ReactComponent as SvgDevWallet } from './glyphs/DevWallet.svg.es.js';
import { ReactComponent as SvgDocs } from './glyphs/Docs.svg.es.js';
import { ReactComponent as SvgEmpty } from './glyphs/Empty.svg.es.js';
import { ReactComponent as SvgExclamationShield } from './glyphs/ExclamationShield.svg.es.js';
import { ReactComponent as SvgFeedback } from './glyphs/Feedback.svg.es.js';
import { ReactComponent as SvgFinancial } from './glyphs/Financial.svg.es.js';
import { ReactComponent as SvgHouse } from './glyphs/House.svg.es.js';
import { ReactComponent as SvgId } from './glyphs/ID.svg.es.js';
import { ReactComponent as SvgKey } from './glyphs/Key.svg.es.js';
import { ReactComponent as SvgLockShield } from './glyphs/LockShield.svg.es.js';
import { ReactComponent as SvgMail } from './glyphs/Mail.svg.es.js';
import { ReactComponent as SvgNft } from './glyphs/NFT.svg.es.js';
import { ReactComponent as SvgNftCollection } from './glyphs/NFTCollection.svg.es.js';
import { ReactComponent as SvgOrgWallet } from './glyphs/OrgWallet.svg.es.js';
import { ReactComponent as SvgOtherProduct } from './glyphs/OtherProduct.svg.es.js';
import { ReactComponent as SvgPaymaster } from './glyphs/Paymaster.svg.es.js';
import { ReactComponent as SvgProgrammableWallet } from './glyphs/ProgrammableWallet.svg.es.js';
import { ReactComponent as SvgRebate } from './glyphs/Rebate.svg.es.js';
import { ReactComponent as SvgRefresh } from './glyphs/Refresh.svg.es.js';
import { ReactComponent as SvgRegionLock } from './glyphs/RegionLock.svg.es.js';
import { ReactComponent as SvgSdk } from './glyphs/SDK.svg.es.js';
import { ReactComponent as SvgSmartContracts } from './glyphs/SmartContracts.svg.es.js';
import { ReactComponent as SvgTest } from './glyphs/Test.svg.es.js';
import { ReactComponent as SvgToken } from './glyphs/Token.svg.es.js';
import { ReactComponent as SvgUsdc } from './glyphs/USDC.svg.es.js';
import { ReactComponent as SvgUserWallet } from './glyphs/UserWallet.svg.es.js';
import { ReactComponent as SvgWarning } from './glyphs/Warning.svg.es.js';
import { ReactComponent as SvgWeb3 } from './glyphs/Web3.svg.es.js';
import { ReactComponent as SvgX } from './glyphs/X.svg.es.js';

/**
 * List of Glyphs.
 */ const SvgGlyphs = {
    AddAddress: SvgAddAddress,
    AddAllowListed: SvgAddAllowListed,
    AddPayment: SvgAddPayment,
    AllContracts: SvgAllContracts,
    Blog: SvgBlog,
    Build: SvgBuild,
    CheckInCircle: SvgCheckInCircle,
    Clock: SvgClock,
    ContractTemplate: SvgContractTemplate,
    CreditCard: SvgCreditCard,
    Defi: SvgDefi,
    DevWallet: SvgDevWallet,
    Docs: SvgDocs,
    Empty: SvgEmpty,
    ExclamationShield: SvgExclamationShield,
    Feedback: SvgFeedback,
    Financial: SvgFinancial,
    House: SvgHouse,
    ID: SvgId,
    Key: SvgKey,
    LockShield: SvgLockShield,
    Mail: SvgMail,
    NFT: SvgNft,
    NFTCollection: SvgNftCollection,
    OrgWallet: SvgOrgWallet,
    OtherProduct: SvgOtherProduct,
    ProgrammableWallet: SvgProgrammableWallet,
    Rebate: SvgRebate,
    Refresh: SvgRefresh,
    RegionLock: SvgRegionLock,
    SDK: SvgSdk,
    SmartContracts: SvgSmartContracts,
    Paymaster: SvgPaymaster,
    Test: SvgTest,
    Token: SvgToken,
    USDC: SvgUsdc,
    UserWallet: SvgUserWallet,
    Warning: SvgWarning,
    Web3: SvgWeb3,
    X: SvgX
};

export { SvgGlyphs };
//# sourceMappingURL=Glyph.Glyphs.es.js.map
